'use strict';

import React from 'react'

import { search } from '@root/utility'

import Layout from '@Layout/ECFront'

import DataList from '@/DataList'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'
import Image     from '@Pure/Image'
import Loader    from '@Pure/Loader'
import Logo      from '@Pure/Logo'

let app = window.app;

export default class PartnerAccessPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			data: [],
			references: []
		};

		this.handleSessionChange = this.handleSessionChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (source) =>
	{
		if (app.state.session.partners?.[0] === undefined) return;

		const component = this, props = this.props, config = this.props.config;

		let filter_query =
		{
			id: app.state.session.partners
		};

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'partner',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				data: response.data,
				references: response.references || []
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'Products'] } />
			);
		}

		let data = component.state.data;

		data
		.filter(partner => Boolean(partner.category))
		.forEach(function (partner)
		{
			let category = (state.references
			.find(infos => infos.model === 'category') || { data: [] })
			.data.find(category => category.id === partner.category);

			if (category)
			{
				partner._category = category;
			}
		});

		data
		.filter(partner => Boolean(partner.place))
		.forEach(function (partner)
		{
			let place = state.references
			.find(infos => infos.model === 'place')
			.data.find(place => place.id === partner.place);

			if (place)
			{
				partner._places = place.name;
			}
		});

		data = data
		.sort(function (a, b)
		{
			return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
		});

		let partners = data
		.map(function (partner, key)
		{
			let category, place;

			if (partner._category)
			{
				category =
				(
					<div className="c-model-preview__themes">
						<div className="c-model-preview__theme">
							{ partner._category.name }
						</div>
					</div>
				);
			}

			if (partner._places)
			{
				place =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner._places }
					</div>
				);
			}
			else if (partner.city)
			{
				place =
				(
					<div className="c-model-preview__places">
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner.city }
					</div>
				);
			}

			let short_description = partner.discount_infos.split('<br>').join('');
			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			let thumbnail;

			if (partner.logo && partner.logo[0])
			{
				thumbnail = partner.logo[0].url;
			}
			else if (partner.images && partner.images[0])
			{
				thumbnail = partner.images[0].url;
			}

			if (thumbnail)
			{
				thumbnail =
				(
					<Image className="c-model-preview__img" src={ thumbnail } />
				);
			}
			else
			{
				thumbnail =
				(
					<Logo className="c-model-preview__img default" type="svg"
						synergies={ true } />
				);
			}

			let displayed_name = partner.name;

			if (partner.city)
			{
				displayed_name += ' (' + partner.city + ')';
			}

			let output =
			(
				<div className="c-model-preview-item partner o-grid__item u-flex"
					key={ partner.id + key }>

					<div className="c-model-preview c-model-preview--partner">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/espace-partenaires/' + partner.id }>
								{ thumbnail }
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/espace-partenaires/' + partner.id }
								className="c-model-preview__title-link">
								{ displayed_name }
							</Link>
						</h2>

						{ category }

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							{ place }

							<div className="c-model-preview__buttons">
								<Link href={ '/espace-partenaires/' + partner.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Modifier
								</Link>

								<Link href={ '/accueil/espace-partenaires/partenaires/' + partner.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		let categories = (component.state.references
		.find(infos => infos.model === 'category') || { data: [] })
		.data
		.sort(function (a, b)
		{
			return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
		})
		.map(function (category)
		{
			let output =
			(
				<option value={ category.id } key={ category.id }>
					{ category.name }
				</option>
			);

			return output;
		});

		var output =
		(
			<Layout history={ props.history } page_title="Partenaires">

				<div className="page-content">

					<div className="o-content">

						<div className="c-title u-no-margin-top u-margin-bottom-20">
							<h2 className="c-title__txt">Fiches partenaire</h2>
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-4 u-flex">
								{ loader || partners }
							</div>

						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}